import React from 'react'
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import _ from 'lodash';

import {getSubstancesByName, setSubstances} from "../../redux/actions/substance";
import TagsInput from 'react-tagsinput';

import ProductGeneralAutosuggest from "./ProductGeneralAutosuggest/ProductGeneralAutosuggest.jsx";


class ProductSubstanceTags extends React.Component {
    constructor(props) {
        super(props);

        this.debouncedGetSubstances = _.debounce((name) => this.props.getSubstancesByName(name), 1000);
    }

    componentWillUnmount() {
        this.props.setSubstances([]);
    }

    render () {

        return <TagsInput
            renderInput={ProductGeneralAutosuggest}
            value={this.props.value}
            onChange={this.props.onChange}
            tagProps={{className: 'react-tagsinput-tag tag-fill tag-azure' }}
            inputProps={{
                suggestions: this.props.substances,
                clearSuggestions: () => {this.props.setSubstances([])},
                getSuggestions: (val) => {this.debouncedGetSubstances(val)},
                placeholder: this.props.placeholder,
                style: {width: '100%'},
                nameColumn: 'name',
            }}
        />
    }
}

const mapStateToProps = state => {
    return {
        loadingSubstances: state.status.loadingSubstances,
        substances: state.substances.substances
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getSubstancesByName: name => {
            dispatch(getSubstancesByName(name));
        },
        setSubstances: val => {
            dispatch(setSubstances(val));
        }
    }
};

ProductSubstanceTags.propTypes = {
    loadingSubstances: PropTypes.bool,
    substances: PropTypes.array,

    getSubstancesByName: PropTypes.func,
    setSubstances: PropTypes.func,

    onChange: PropTypes.func,

    value: PropTypes.array,
    placeholder: PropTypes.string
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductSubstanceTags);